export const environment = {
  production: true,
  //version: '2025.04.29.1',
  //apiUrl: '/FormEngine/',
  apiUrl: '/FormEngine/',
  loginUrl: 'https://i.nccu.edu.tw/',
  authTokenKey: 'form-engine-auth-token'
};
